<template>
  <div>
    <VoucherDetail />
  </div>
</template>

<script>
import VoucherDetail from '@/components/Voucher/detail'

export default {
  components: {
    VoucherDetail,
  },
}
</script>
